import { render, staticRenderFns } from "./transferShipmentsToCargoWiseAction.vue?vue&type=template&id=05b59a4e&"
import script from "./transferShipmentsToCargoWiseAction.vue?vue&type=script&lang=js&"
export * from "./transferShipmentsToCargoWiseAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports